import React from "react";
import { useNavigate } from "react-router-dom";
import { useLocalization } from "../../stores/localizationContext";
import imgManageClasses from "../../assets/images/manage_classes.png";
import imgMyEarnings from "../../assets/images/my_earnings.png";
import "./Admin.scss";

export const Admin: React.FC = () => {
  const { t, lang } = useLocalization();
  const navigate = useNavigate();

  return (
    <main className="admin-page">
      <div className="container">
        <div className="admin-cards">
          <a
            href={`/${lang}/admin/classes/`}
            className="admin-card"
            onClick={(e) => {
              e.preventDefault();
              navigate(`/${lang}/admin/classes/`);
            }}
          >
            <div className="admin-card__icon">
              <img src={imgManageClasses} alt={t("manage_my_classes_label")} />
            </div>
            <span className="admin-card__label">
              {t("manage_my_classes_label")}
            </span>
          </a>

          <a
            href={`/${lang}/admin/earnings/`}
            className="admin-card"
            onClick={(e) => {
              e.preventDefault();
              navigate(`/${lang}/admin/earnings/`);
            }}
          >
            <div className="admin-card__icon">
              <img src={imgMyEarnings} alt={t("my_earnings_label")} />
            </div>
            <span className="admin-card__label">
              {t("my_earnings_label")}
            </span>
          </a>
        </div>
      </div>
    </main>
  );
};

export default Admin;
